import { motion } from "motion/react";

export function AnimatedDivider({ className = "h-[1px] bg-white/20", delay = 0 }: { className?: string, delay?: number }) {
  return (
    <motion.div
      initial={{ scaleX: 0, opacity: 0 }}
      animate={{ scaleX: 1, opacity: 1 }}
      transition={{ 
        scaleX: { duration: 0.5, ease: [0.19, 1, 0.22, 1], delay },
        opacity: { duration: 0.4, ease: "easeOut", delay }
      }}
      className={`w-full origin-left block ${className}`}
    />
  );
}
